var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { EntityViewAside } from './entity-view-aside';
import { usePageEntity } from '../hooks/use-page-entity';
import { MoreDivider } from '../elements/more-divider';
import AnimateHeight from 'react-animate-height';
import { useLang } from '../hooks/use-lang';
import { useActiveThemeMode } from '../hooks/use-active-theme-mode';
import { useLayoutRenderCheck } from '../hooks/use-layout-render-check';
var cls = classNames('slice-entity-view-aside-mobile');
export var SliceEntityViewAsideMobileDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: block;\n    position: relative;\n    margin-bottom: ", ";\n\n    ", "\n\n    .shp--slice-layout {\n      background: transparent;\n    }\n\n    background: ", ";\n    border-radius: ", ";\n   \n  "], ["\n    display: block;\n    position: relative;\n    margin-bottom: ", ";\n\n    ", "\n\n    .shp--slice-layout {\n      background: transparent;\n    }\n\n    background: ", ";\n    border-radius: ", ";\n   \n  "])), theme.UNIT(4), function (_a) {
    var isExpanded = _a.isExpanded,
      isDarkMode = _a.isDarkMode;
    return !isExpanded && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 150px;\n        background: linear-gradient(\n          to top,\n          ", " 15%,\n          ", " 20%,\n          ", " 40%,\n          ", " 70%,\n          ", " 100%\n        );\n        pointer-events: none;\n      }\n    "], ["\n      position: relative;\n      &::after {\n        content: '';\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        height: 150px;\n        background: linear-gradient(\n          to top,\n          ", " 15%,\n          ", " 20%,\n          ", " 40%,\n          ", " 70%,\n          ", " 100%\n        );\n        pointer-events: none;\n      }\n    "])), isDarkMode ? 'rgba(30, 30, 30, 1)' : 'rgba(255, 255, 255, 1)', isDarkMode ? 'rgba(30, 30, 30, 0.9)' : 'rgba(255, 255, 255, 0.9)', isDarkMode ? 'rgba(30, 30, 30, 0.6)' : 'rgba(255, 255, 255, 0.6)', isDarkMode ? 'rgba(30, 30, 30, 0.3)' : 'rgba(255, 255, 255, 0.3)', isDarkMode ? 'rgba(30, 30, 30, 0)' : 'rgba(255, 255, 255, 0)');
  }, theme.COLOR('app-chrome'), theme.UNIT(2)),
  desktopDevice: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var ExpandableWrapperStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var MoreDividerStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    bottom: -", ";\n    left: 0;\n    margin: 0 auto;\n\n    ", ",\n    \n  "], ["\n    position: absolute;\n    bottom: -", ";\n    left: 0;\n    margin: 0 auto;\n\n    ", ",\n    \n  "])), theme.UNIT(5), function (_a) {
    var _isExpanded = _a._isExpanded;
    return _isExpanded && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      bottom: -", ";\n    "], ["\n      bottom: -", ";\n    "])), theme.UNIT(10));
  })
});
// -------- Components -------->
var My = {
  NAME: 'SliceEntityViewAsideMobile',
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  ExpandableWrapper: styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ExpandableWrapperStyles),
  MoreDivider: styled(MoreDivider)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MoreDividerStyles)
};
export var SliceEntityViewAsideMobile = function (props) {
  var _a = useComponentProps(My.NAME, props, SliceEntityViewAsideMobileDefaultProps),
    className = _a.className,
    children = _a.children,
    entity = _a.entity;
  var _b = __read(React.useState(false), 2),
    isExpanded = _b[0],
    setIsExpanded = _b[1];
  var t = useLang();
  var activeEntity = usePageEntity();
  var dividerHeight = entityTypeNameFor(activeEntity) === 'Economy' ? 400 : 100;
  var shouldRender = useLayoutRenderCheck(activeEntity).shouldRender;
  var isDark = useActiveThemeMode().isDark;
  if (!shouldRender) {
    return null;
  }
  ;
  return React.createElement(My.Container, {
    isDarkMode: isDark,
    isExpanded: isExpanded,
    className: cls.name(className)
  }, React.createElement(AnimateHeight, {
    duration: 300,
    easing: 'ease-out',
    height: isExpanded ? 'auto' : dividerHeight
  }, React.createElement(EntityViewAside, {
    entity: activeEntity
  })), React.createElement(My.MoreDivider, {
    _isExpanded: isExpanded,
    minimise: isExpanded,
    showLine: false,
    onClick: function (event) {
      event.stopPropagation();
      setIsExpanded(function (isExpanded) {
        return !isExpanded;
      });
    }
  }, t('Show More')));
};
SliceEntityViewAsideMobile.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;